"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.right = exports.bottom = exports.IRect = void 0;
var immutable_1 = require("../../immutable");
exports.IRect = (0, immutable_1.IRecord)({
    top: 0,
    left: 0,
    width: 0,
    height: 0
});
var bottom = function (r) { return r.top + r.height; };
exports.bottom = bottom;
var right = function (r) { return r.left + r.width; };
exports.right = right;
